import { api } from "../api";

export const getAllUsers = function (callback) {
    const URL = "/users";

    api
        .get(URL)
        .then((response) => {
            console.log("Response:", response, URL);
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error: getAllUsers. " + error);
        });
};

export const getMe = function (callback) {
    const URL = "/users/info/me";

    api
        .get(URL)
        .then((response) => {
            // console.log(response.data)
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const getAllUsersGrid = function (data = {}, callback) {
    const URL = "/users/grid";

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const saveUser = function (data = {}, callback) {
    const URL = "/users";

    api
        .post(URL, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const updateUser = function (id, data = {}, callback) {
    const URL = `/users/${id}`;

    api
        .put(URL, data)
        .then((response) => {

            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const deleteUser = function (id, callback) {
    const URL = `/users/${id}`;

    api
        .delete(URL)
        .then((response) => {

            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};

export const getUser = function (id, callback) {
    const URL = `/users/${id}`;

    api
        .get(URL)
        .then((response) => {

            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. " + error);
        });
};